<template>
  <div>
    <div class="head-box">
      <h4>服务资源</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增服务资源</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('ServiceResources,export')"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-in:state|array-integer#and': '0,1',
              beanName: 'serviceResource',
              title: '服务资源列表'
            })
          "
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          :row-class-name="osg.lastRowClassName"
        >
          <el-table-column label="名称" fixed show-overflow-tooltip prop="name" width="180px">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="$router.push({ path: `/ServiceResource/${scope.row._id}` })"
                type="text"
              >
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="order"
            label="资源编号"
            width="80px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="resourceType"
            label="资源类型"
            :formatter="formatResourceType"
            width="80px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="资源" prop="relatedRecordId" width="80px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.relatedRecordId">
                {{ formatUser(scope.row.relatedRecordId) }}
              </span>
              <span v-else-if="scope.row.serviceCrewId">
                {{ formatOrg(scope.row.serviceCrewId) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="tenantId != '4551453470943235290'"
            prop="resourceRoles"
            label="资源角色"
            :formatter="formatResourceRoles"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="resourceLevel"
            label="资源等级"
            v-if="
              tenantId == '1340835581184723420'
                ? dataAuth > 3 ||
                  dataAuth == 0 ||
                  dataAuthId == '9144282109161981269' ||
                  dataAuthId == '7528632979004829751'
                  ? true
                  : false
                : false
            "
            :formatter="formatResourceLevel"
          ></el-table-column>
          <el-table-column
            width="80px"
            show-overflow-tooltip
            prop="parameterList"
            label="接单上限"
            v-if="
              tenantId == '1340835581184723420'
                ? dataAuth > 3 ||
                  dataAuth == 0 ||
                  dataAuthId == '9144282109161981269' ||
                  dataAuthId == '7528632979004829751'
                  ? true
                  : false
                : false
            "
            :formatter="formatParameter"
          ></el-table-column>
          <el-table-column
            prop="score"
            label="技术服务分"
            :formatter="formatScore"
            v-if="tenantId == '1340835581184723420'"
          ></el-table-column>
          <el-table-column
            prop="exts.plateNumber"
            label="今日所在车辆"
            width="100px"
            v-if="tenantId == '2530349872480957853'"
          ></el-table-column>
          <el-table-column
            prop="workType"
            label="工作状态"
            :formatter="formatWorkState"
          ></el-table-column>
          <el-table-column
            prop="exts.integral"
            label="权重积分"
            width="100px"
            v-if="tenantId == '2530349872480957853'"
          ></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="lastKnownLocation" label="位置"></el-table-column>
          <el-table-column
            prop="serviceType"
            label="服务类型"
            :formatter="formatServiceType"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140px"></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ServiceResources,remove')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="服务资源" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
      >
        <el-form-item label="资源名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item
          label="资源编号"
          prop="order"
          :rules="{
            required: false
          }"
        >
          <el-input v-model="formData.order" type="number"></el-input>
        </el-form-item>
        <el-form-item label="资源描述" prop="description">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item label="资源类型" prop="resourceType">
          <el-select v-model="formData.resourceType" clearable @change="resourceTypeChange">
            <el-option
              v-for="item in options.resourceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择资源"
          prop="serviceCrewId"
          v-if="formData.resourceType == 'serviceCrew' || formData.resourceType == 'partner'"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择资源'
          }"
        >
          <el-select
            v-model="formData.serviceCrewId"
            filterable
            remote
            :remote-method="getOrg"
            clearable
            @clear="getOrg"
            @change="getServiceType"
            placeholder="请先选择资源类型（支持名称搜索）"
          >
            <el-option
              v-for="item in options.org"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="relatedRecordId"
          label="选择资源"
          v-if="formData.resourceType != 'serviceCrew' && formData.resourceType != 'partner'"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择资源'
          }"
        >
          <el-select
            v-model="formData.relatedRecordId"
            filterable
            remote
            :remote-method="getUser"
            clearable
            @clear="getUser"
            @change="$forceUpdate()"
            placeholder="请先选择资源类型（支持姓名搜索）"
          >
            <el-option
              v-for="item in options.user"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @click.native="serviceResourceClick(item)"
            >
              <span>{{ item.label }}</span>
              <span style="float: right; color: #c3C6CD; font-size: 13px">
                {{ formatRoles(item.roleIds) }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="tenantId != '4551453470943235290'"
          label="资源角色"
          prop="resourceRoles"
        >
          <el-select v-model="formData.resourceRoles" multiple clearable>
            <el-option
              v-for="item in options.resourceRoles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template
          v-if="
            tenantId == '1340835581184723420'
              ? formData.resourceRoles && formData.resourceRoles.indexOf('1') != -1
                ? dataAuth > 3 ||
                  dataAuth == 0 ||
                  dataAuthId == '9144282109161981269' ||
                  dataAuthId == '7528632979004829751'
                  ? true
                  : false
                : false
              : false
          "
        >
          <el-form-item
            label="资源等级"
            prop="resourceLevel"
            :rules="{
              required:
                formData.resourceType == 'technician' &&
                formData.resourceRoles &&
                formData.resourceRoles.indexOf('1') != -1,
              trigger: 'change',
              message: '请选择资源等级'
            }"
          >
            <el-select v-model="formData.resourceLevel" clearable @change="resourceLevelChange">
              <el-option
                v-for="item in options.resourceLevel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <template
            v-if="
              formData.resourceLevel &&
                (tenantId == '1340835581184723420'
                  ? formData.resourceRoles && formData.resourceRoles.indexOf('1') != -1
                    ? dataAuth > 3 ||
                      dataAuth == 0 ||
                      dataAuthId == '9144282109161981269' ||
                      dataAuthId == '7528632979004829751'
                      ? true
                      : false
                    : false
                  : true)
            "
          >
            <el-form-item
              v-for="(param, j) in formData.parameter"
              :key="j + '1'"
              :label="param.keyName"
              :rules="{
                required: true
              }"
            >
              <el-input-number
                v-model="param.value"
                :min="0"
                :precision="0"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="工作状态" prop="workType">
          <el-select v-model="formData.workType" clearable>
            <el-option
              v-for="item in options.workState"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <template>
          <el-form-item
            label="服务类型"
            prop="serviceType"
            v-if="formData.resourceType == 'partner'"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择服务类型'
            }"
          >
            <el-select
              v-model="formData.serviceType"
              multiple
              placeholder="请选择服务类型"
              disabled
            >
              <el-option
                v-for="item in options.serviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="服务类型"
            prop="serviceType"
            v-else
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择服务类型'
            }"
          >
            <el-select v-model="formData.serviceType" multiple placeholder="请选择服务类型">
              <el-option
                v-for="item in options.serviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="资源位置">
          <el-input
            type="textarea"
            v-model="formData.lastKnownLocation"
            :disabled="formData.resourceType != 'serviceCrew' && formData.resourceType != 'partner'"
            @change="getGeocode"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model="formData.gpsPoint.longitude" disabled></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="formData.gpsPoint.latitude" disabled></el-input>
        </el-form-item>
        <el-form-item label="位置更新时间">
          <el-input v-model="formData.lastKnownLocationDate" disabled></el-input>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="extField.frontEndConfig.number ? Number(item.value) : item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Templates from '../Templates.vue';
export default {
  components: { Templates },
  name: 'serviceResources',
  data() {
    window.$this = this;
    return {
      tenantId: '',
      dataAuth: '',
      dataAuthId: '', //当前登陆人的角色id
      name: 'serviceResource',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        relatedRecordId: '',
        serviceCrewId: '',
        parameter: [],
        exts: {},
        gpsPoint: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_resourceType: { codeId: 'resourceType' },
        codecfg_resourceLevel: { codeId: 'resourceLevel' },
        codecfg_resourceRoles: { codeId: 'resourceRoles' },
        codecfg_workState: { codeId: 'workState' },
        codecfg_serviceType: { codeId: 'serviceType' },
        org: [],
        user: [],
        roles: [],
        formatUser: [],
        formatOrg: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.dataAuth = JSON.parse(sessionStorage['currentRole']).dataAuth;
    this.dataAuthId = JSON.parse(sessionStorage['currentRole'])._id;

    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'serviceResource',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (var item of res.data) {
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.$util.renderExtField(this.extFields, this.formData);
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
        });
      },
      { noload: true }
    );
    this.getRoles();
  },
  methods: {
    formatServiceType(row, column, cellValue) {
      return this.osg.codelabelForArray('serviceType', cellValue);
    },
    formatRoles(value) {
      return this.osg.codelabelForArray('roles', value);
    },
    formatUser(value) {
      return this.osg.codelabel('formatUser', value);
    },
    formatScore(row) {
      let users = this.options.formatUser;
      for (let user of users) {
        if (row.relatedRecordId == user._id) {
          return user.score;
        }
      }
    },
    formatOrg(value) {
      return this.osg.codelabel('formatOrg', value);
    },
    formatResourceType(row, column, cellValue) {
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatResourceRoles(row, column, cellValue) {
      return this.osg.codelabelForArray('resourceRoles', cellValue);
    },
    formatResourceLevel(row, column, cellValue) {
      return this.osg.codelabel('resourceLevel', cellValue);
    },
    formatParameter(row, column, cellValue) {
      let parameter = cellValue || [];
      let str = '';
      parameter.map(item => {
        str += item.keyName + '：' + item.value + '；';
      });
      return str;
    },
    formatWorkState(row, column, cellValue) {
      return this.osg.codelabel('workState', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/serviceResource/query.do', params, async res => {
        //列表渲染的relatedRecordId和serviceCrewId
        let userList = [],
          orgList = [];
        res.data.map(item => {
          if (item.resourceType == 'serviceCrew' || item.resourceType == 'partner') {
            orgList.push(item.serviceCrewId);
          } else {
            userList.push(item.relatedRecordId);
          }
        });
        if (orgList.length > 0) {
          await new Promise(resolve => {
            this.osg.ajax(
              'org/query.do',
              {
                page: 1,
                rows: orgList.length,
                orgType: this.formData.resourceType,
                'in:_id|array#and': orgList.join(','),
                notFilterOrgId: '1', //解决合伙人内勤查不到当前组织 无法返显的问题
                sortField: 'createTime',
                sortOrder: 'desc'
              },
              res => {
                res.data.orgList.map(item => {
                  item.label = item.orgName;
                  item.value = item._id;
                });
                this.options.formatOrg = res.data.orgList;
                resolve();
              },
              {
                noload: true
              }
            );
          });
        }
        if (userList.length > 0) {
          await new Promise(resolve => {
            let params = {
              page: 1,
              rows: userList.length,
              tenantId: this.tenantId,
              'in:_id|array#and': userList.join(','),
              sortField: 'createTime',
              sortOrder: 'desc'
            };
            this.osg.ajax(
              'user/query.do',
              params,
              res => {
                res.data.map(item => {
                  item.label = item.name;
                  item.value = item._id;
                });
                this.options.formatUser = res.data;
                resolve();
              },
              {
                noload: true
              }
            );
          });
        }
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        parameter: [
          {
            sourceType: '1',
            sourceTypeId: '',
            keyName: '日接单数上限',
            key: 'guanjia_S_dayCount',
            value: ''
          },
          {
            sourceType: '1',
            sourceTypeId: '',
            keyName: '月接单数上限',
            key: 'guanjia_S_monthCount',
            value: ''
          }
        ],
        exts: {},
        gpsPoint: {},
        relatedRecordId: '',
        serviceCrewId: ''
      };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.options.user = [];
      this.options.org = [];
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      row.gpsPoint = row.gpsPoint || {};
      // 获取参数表关联数据
      if (row.resourceLevel) {
        this.getParameter(row._id, res => {
          if (res.data.length > 0) {
            row.parameter = res.data;
          } else {
            row.parameter = [
              {
                sourceType: '1',
                sourceTypeId: row._id,
                keyName: '日接单数上限',
                key: 'guanjia_S_dayCount',
                value: ''
              },
              {
                sourceType: '1',
                sourceTypeId: row._id,
                keyName: '月接单数上限',
                key: 'guanjia_S_monthCount',
                value: ''
              }
            ];
          }
          this.formData = row;
        });
      } else {
        row.parameter = [
          {
            sourceType: '1',
            sourceTypeId: row._id,
            keyName: '日接单数上限',
            key: 'guanjia_S_dayCount',
            value: ''
          },
          {
            sourceType: '1',
            sourceTypeId: row._id,
            keyName: '月接单数上限',
            key: 'guanjia_S_monthCount',
            value: ''
          }
        ];
        this.formData = row;
      }
      this.formData = row;
      if (this.formData.resourceType == 'serviceCrew' || this.formData.resourceType == 'partner') {
        this.getOrg();
      } else {
        this.getUser();
      }
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.formData.resourceLevel) {
          for (let param of this.formData.parameter) {
            if (
              !param.value &&
              param.value !== 0 &&
              (this.dataAuth > 3 ||
                this.dataAuth == 0 ||
                this.dataAuthId == '9144282109161981269' ||
                this.dataAuthId == '7528632979004829751')
            ) {
              this.osg.toast('请填写' + param.keyName, 'warning');
              return;
            }
          }
        }
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveExtField(this.extFields, params);
        //保存经纬度
        params['gpsPoint.longitude'] = params.gpsPoint.longitude;
        params['gpsPoint.latitude'] = params.gpsPoint.latitude;
        delete params.gpsPoint;
        let parameter = this.$util.deepCopy(params.parameter);
        delete params.parameterList;
        debugger;
        this.osg.ajax('biz/serviceResource/upsert.do', params, res => {
          this.openDetail = false;
          this.getData();
          this.osg.toast('保存成功！');
          // 保存参数表
          if (
            params.resourceLevel &&
            (this.tenantId == '1340835581184723420'
              ? params.resourceRoles && params.resourceRoles.indexOf('1') != -1
                ? true
                : false
              : true)
          ) {
            if (
              this.dataAuth > 3 ||
              this.dataAuth == 0 ||
              this.dataAuthId == '9144282109161981269' ||
              this.dataAuthId == '7528632979004829751'
            ) {
              // 保存参数表关联数据
              for (let formData of parameter) {
                formData.sourceTypeId = res.entity._id;
                this.osg.ajax('parameter/upsert.do', formData, () => {}, {
                  noload: true
                });
              }
            }
          } else {
            // 删除参数表关联数据
            for (let param of this.formData.parameter) {
              if (param._id) {
                this.osg.ajax(`parameter/remove/${param._id}.do`, {}, () => {}, {
                  noload: true
                });
              }
            }
          }
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`biz/serviceResource/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/serviceResource/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/serviceResource/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //修改服务资源类型
    resourceTypeChange() {
      this.formData.relatedRecordId = '';
      this.formData.serviceCrewId = '';
      this.formData.exts.phone = '';
      this.formData.partnerServiceType = [];
      this.$forceUpdate();
      if (this.formData.resourceType == 'serviceCrew' || this.formData.resourceType == 'partner') {
        this.getOrg();
      } else {
        this.getUser();
        //服务资源是user时，位置信息置空通过定位来更新。
        this.formData.gpsPoint = {};
        this.formData.lastKnownLocation = '';
        this.formData.lastKnownLocationDate = '';
      }
    },
    getServiceType() {
      let params = {
        'is:orgId|string#and': this.formData.serviceCrewId
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          res.data.map(data => {
            this.$set(this.formData, 'serviceType', data.serviceType);
          });
        },
        { noload: true }
      );
    },
    serviceResourceClick(row) {
      this.formData.exts.phone = row.phone;
    },
    /*//选择服务资源
    relatedChange(id) {
      if (id) {
        if (
          this.formData.resourceType == "serviceCrew" ||
          this.formData.resourceType == "partner"
        ) {
          let org = this.options.org.find(item => {
            return item._id == id;
          });
          this.formData.relatedName = org.label;
        } else {
          let user = this.options.user.find(item => {
            return item._id == id;
          });
          this.formData.relatedName = user.label;
        }
      } else {
        this.formData.relatedName = "";
      }
      this.$forceUpdate();
    },*/
    //获取组织
    getOrg(query) {
      this.osg.ajax(
        'org/query.do',
        {
          orgType: this.formData.resourceType,
          'regex:orgName|string#and': query,
          'exists:serviceResourceId|boolean#or': false,
          'is:serviceResourceId|string#or': this.formData._id
        },
        res => {
          let optHas = false;
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
            // 判断关联资源下拉选项是否包含当前org
            if (item.serviceResourceId == this.formData._id) {
              optHas = true;
            }
          });
          // 在options.org补充当前org数据，解决获取不到当前org的问题
          if (!optHas) {
            for (let item of this.options.formatOrg) {
              if (item.serviceResourceId == this.formData._id) {
                res.data.orgList.push(item);
                break;
              }
            }
          }

          this.options.org = res.data.orgList;
        },
        { noload: true }
      );
    },
    //获取用户
    getUser(query) {
      let params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|array-integer#and': '1',
        tenantId: this.tenantId,
        'regex:name|string#and': query,
        'exists:serviceResourceId|boolean#or': false,
        'is:serviceResourceId|string#or': this.formData._id
      };
      this.osg.ajax(
        'user/query.do',
        params,
        res => {
          let arr = [];
          res.data.map(item => {
            // 不展示超级管理员
            if (item._id != item.tenantId) {
              item.label = item.name;
              item.value = item._id;
              arr.push(item);
            }
          });
          this.options.user = arr;
        },
        { noload: true }
      );
    },
    //获取角色
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        {
          _all: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
          this.$forceUpdate();
        }
      );
    },
    //获取地理编码
    async getGeocode() {
      this.$forceUpdate();
      if (this.formData.lastKnownLocation) {
        this.osg.geocode(this.formData.lastKnownLocation, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.formData.lastKnownLocationDate = new Date()
            .toLocaleString('chinese', {
              hour12: false
            })
            .replace(/\//g, '-');
          this.$forceUpdate();
        });
      }
    },
    // 修改资源等级动态修改参数表关联数据
    resourceLevelChange() {
      if (this.formData.resourceLevel) {
        for (let param of this.formData.parameter) {
          if (param.key) {
            let arr = param.key.split('_');
            param.key = this.formData.resourceLevel + '_' + arr[arr.length - 1];
          }
        }
      } else {
        // 删除资源
      }
    },
    getParameter(sId, callback) {
      this.osg.ajax(
        'parameter/query.do',
        {
          sourceTypeId: sId,
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'key',
          sortOrder: 'asc'
        },
        res => {
          if (callback) callback(res);
        }
      );
    }
  }
};
</script>
